import { IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react'
import { CgOptions } from "react-icons/cg";


export default function TemplateCardOptionsButton({ 
  dsrTemplateId,
  dsrTitle, 
  handleChangeUserActionRequired,
  isAuthor
}) {

  const handleConfirmDeleteTemplate = () => {
    handleChangeUserActionRequired("confirm-delete-template", {
      dsrTemplateId: dsrTemplateId,
      dsrTitle: dsrTitle
    })
  }

  return (
    <>
      <Menu isLazy placement="bottom-end">
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<CgOptions />}
          variant='outline'
          size='2em'
          p='0.25em'
        />
        <MenuList px='0.5em' fontSize='0.875em'>
          {isAuthor && <MenuItem name='make-template-option' className='filter-menu__dropdown-option-display' onClick={() => handleConfirmDeleteTemplate()}>Delete template</MenuItem>}
        </MenuList>
      </Menu>
    </>
  );

}